import React from 'react';
import { reduxForm } from 'redux-form';
import { Button, Modal } from '@syneto/compass-react';
import Form from '../../../../components/forms/form';
import { GRANT_FORM_NAME } from '../../../../constants/compliance-verdicts';
import { verdictScopeLabel, verdictVersionLabel } from './complianceVerdictDisplay';
import { validateComplianceVerdictGrantForm } from './complianceVerdictValidation';

/*
 * Grants an override on a failed compliance check. The scope is the verdict's own and is shown
 * rather than chosen: the API takes it from the verdict, so offering the scope picker here would
 * suggest a choice that does not exist. The reason is asked for because the API records it as the
 * audit justification and rejects a blank one.
 *
 * The modal stays open when the grant fails, so the reason can be kept and resubmitted once the
 * list has been refreshed.
 */
let ComplianceVerdictGrantModal = (props) => {
	const { verdict, componentTypes, componentTypesLoading, grantedBy, handleSubmit, submitting, onConfirm, onCancel } = props;

	return (
		<Modal show={Boolean(verdict)} onHide={onCancel}>
			<Modal.Header>
				<Modal.Title>Grant override</Modal.Title>
			</Modal.Header>

			<Modal.Body>
				<p className="text-value">This appliance failed its compliance check on:</p>

				<dl className="row">
					<dt className="col-4">Appliance</dt>
					<dd className="col-8">{verdict?.serialNumber}</dd>

					<dt className="col-4">Scope</dt>
					<dd className="col-8">{verdictScopeLabel(verdict, componentTypes, componentTypesLoading)}</dd>

					<dt className="col-4">Firmware version</dt>
					<dd className="col-8">{verdictVersionLabel(verdict)}</dd>
				</dl>

				<form noValidate>
					<Form.textarea
						label="Reason"
						name="reason"
						id="grant-reason"
						required
					/>
				</form>

				<p className="mb-1">The appliance will no longer be held to the firmware compliance rules for this scope.</p>
				<p className="text-muted mb-0">Recorded as granted by <span className="text-value">{grantedBy}</span>.</p>
			</Modal.Body>

			<Modal.Footer>
				<Button role="secondary" onClick={onCancel}>Cancel</Button>
				<Button disabled={submitting} onClick={handleSubmit(onConfirm)}>Grant override</Button>
			</Modal.Footer>
		</Modal>
	);
};

ComplianceVerdictGrantModal = reduxForm({
	form: GRANT_FORM_NAME,
	initialValues: { reason: '' },
	validate: validateComplianceVerdictGrantForm,
	shouldValidate: () => { return true; }
})(ComplianceVerdictGrantModal);

export default ComplianceVerdictGrantModal;
